<div class="container">
  <header class="page-heading mb-lg">
    <span class="legal-eyebrow">Your Data</span>
    <h1>Delete Your Account &amp; Data</h1>
    <p>How to permanently delete your Every Rupee Spent account and the personal data attached to it.</p>
  </header>

  <section class="card legal-content">
    <article class="legal-section" id="self-service">
      <h2>1. Delete it yourself (instant)</h2>
      <p>
        If you can log in, this is the fastest way. Go to <a routerLink="/my-account">My Account</a> on the website,
        or the "My Account" screen in the mobile app, and use the "Delete account" section at the bottom of the
        page. You'll need to enter your current password and type <strong>DELETE</strong> to confirm — this cannot
        be undone.
      </p>
      <p>
        If you're a landlord using the Rental Management System with active properties or tenants, you'll be asked
        to archive or close those out first. This protects your tenants' records from being deleted as a side
        effect of your account deletion while a tenancy may still be active.
      </p>
    </article>

    <article class="legal-section" id="request">
      <h2>2. Can't log in? Request deletion instead</h2>
      <p>
        If you've lost access to your account, <a routerLink="/contact">contact us</a> from the email address
        registered to the account and ask us to delete it. We'll verify the request and delete your data within a
        reasonable period.
      </p>
    </article>

    <article class="legal-section" id="what-happens">
      <h2>3. What gets deleted, and what we keep</h2>
      <p>Once your account is deleted:</p>
      <ul>
        <li>Your email and display name are replaced with an anonymised placeholder, and your password is invalidated.</li>
        <li>Your budgets, expenses, reminders, feedback, and any saved Rental Agreement Generator drafts are permanently deleted.</li>
        <li>Your notification preferences and push notification tokens are deleted.</li>
        <li>Your Rental Management System data — properties, tenants, leases, documents and related records — is permanently deleted, once there are no active properties or tenants left to protect.</li>
      </ul>
      <p>
        As set out in our <a routerLink="/privacy" fragment="retention">Privacy Policy</a>, we retain payment and
        transaction records (amounts, order/payment IDs, dates) as required for tax and fraud-prevention
        obligations — these records do not contain your name or contact details once your account is anonymised.
      </p>
    </article>
  </section>

  <p class="legal-footnote">
    See also our <a routerLink="/privacy">Privacy Policy</a>, or <a routerLink="/">return home</a>.
  </p>
</div>
